import * as icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { FadeUp, Chapter, RevealLines } from "./motion";
import { useLead } from "@/App";

export default function Services() {
  const { openConsult } = useLead();
  return (
    <section id="services" data-testid="services-section" className="bg-[#F7F5F2] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="02" title="What We Craft" />
        <div className="mt-8 flex flex-wrap items-end justify-between gap-6">
          <RevealLines
            className="font-display text-4xl tracking-tight text-[#1B1B1B] md:text-6xl"
            lines={[<>Every corner of your home,</>, <><span className="italic text-[#B68D40]">mastered.</span></>]}
          />
          <FadeUp delay={0.3}>
            <p className="max-w-sm text-sm leading-relaxed text-[#2C2C2C]/65">
              Eleven crafts under one roof — each delivered by specialists, each finished to a single standard: flawless.
            </p>
          </FadeUp>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => {
            const Icon = icons[s.icon] || icons.Sparkles;
            return (
              <FadeUp key={s.name} delay={(i % 4) * 0.08} className={s.big ? "sm:col-span-2 sm:row-span-2" : ""}>
                <button
                  onClick={() => openConsult("service_" + s.name.toLowerCase().replace(/\s/g, "_"))}
                  data-testid={`service-card-${s.name.toLowerCase().replace(/\s/g, "-")}`}
                  className={`group relative block w-full overflow-hidden rounded-xl text-left ${s.big ? "h-full min-h-[420px]" : "h-[220px]"} bg-[#E7DDD0]`}
                >
                  <img
                    src={s.img}
                    alt={`${s.name} interior design Bangalore`}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover opacity-90 transition-[transform,opacity] duration-700 ease-out group-hover:scale-105 group-hover:opacity-40"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1B1B1B]/80 via-[#1B1B1B]/10 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-6">
                    <div>
                      <Icon size={22} className="mb-3 text-[#B68D40]" />
                      <h3 className={`font-display text-[#F7F5F2] ${s.big ? "text-3xl" : "text-xl"}`}>{s.name}</h3>
                      <p className="mt-1 max-w-[240px] text-xs text-[#F7F5F2]/70 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                        {s.desc}
                      </p>
                    </div>
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#F7F5F2]/30 text-[#F7F5F2] transition-colors duration-300 group-hover:border-[#B68D40] group-hover:bg-[#B68D40] group-hover:text-[#1B1B1B]">
                      <ArrowUpRight size={16} />
                    </span>
                  </div>
                </button>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
